import * as actionEventtypes from "../constants/eventtypeConstants";

import axios from "axios";

export const getEventtypes = () => async (dispatch) => {
    const { data } = await axios.get("/api/types");
    dispatch({
        type: actionEventtypes.GET_EVENTTYPES_REQUEST,
        payload: data,
    })
}

export const saveAttributeToCatDoc = (key, val, typeChoosen) => async (dispatch, getState) => {
   const { data } = await axios.post("/api/types/attr", { key, val, typeChoosen }); 
   if (data.typeUpdated) {
       dispatch({
           type: actionEventtypes.SAVE_ATTR,
           payload: [...data.typeUpdated],
       })
   }
}

export const newEventtype = (type) => async (dispatch, getState) => {
    const cat = getState().getEventtypes.types;
    const { data } = await axios.post("/api/types", { type });
    if (data.typeCreated) {
        dispatch({
            type: actionEventtypes.INSERT_EVENTTYPE,
            payload: [...cat, data.typeCreated],
        })
    }
}

export const deleteEventtype = (type) => async (dispatch, getState) => {
    const cat = getState().getEventtypes.types;
    const types = cat.filter((item) => item.name !== type);
    const { data } = await axios.delete("/api/types/" + encodeURIComponent(type));
    if (data.typeDeleted) {
        dispatch({
           type: actionEventtypes.DELETE_EVENTTYPE, 
           payload: [...types],
        })
    }
}